import { render } from "./ViewExchange.vue?vue&type=template&id=0ae71f96&scoped=true"
import script from "./ViewExchange.vue?vue&type=script&lang=js"
export * from "./ViewExchange.vue?vue&type=script&lang=js"

import "./ViewExchange.vue?vue&type=style&index=0&id=0ae71f96&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae71f96"]])

export default __exports__